<template>
  <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
    <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
      <div class="form-title-mobile tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-uppercase tw-pt-5 tw-pb-3 lg:tw-hidden">
        Peça aqui o seu <b>Ebook gratuito</b>
      </div>
      <div class="form-title-desktop tw-hidden lg:tw-flex tw-flex-col tw-items-center tw-justify-center tw-uppercase tw-text-white">
        <p>Peça aqui o seu<br><b>Ebook gratuito</b></p>
      </div>
      <fieldset class="tw-px-3 tw-pb-3 lg:tw-px-6 lg:tw-pb-12">
        <validation-provider class="tw-w-full tw-w-block" name="fullName" rules="required|alpha_spaces" v-slot="{ classes }">
          <div class="input-group input-group-name" :class="classes">
            <input type="text"
                   id="input-fullName"
                   placeholder=" "
                   v-model="fullName"
            >
            <label>
              Nome e Apelido
            </label>
          </div>
        </validation-provider>
        <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:pt" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', phone: ' ' }">
          <div class="input-group input-group-phone" :class="classes">
            <input type="tel"
                   id="input-phone"
                   placeholder=" "
                   v-model="phone"
                   v-mask="'999999999'"
            >
            <label>
              Telefone {{ errors [0]}}
            </label>
          </div>
        </validation-provider>
        <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'inválido' }">
          <div class="input-group input-group-email" :class="classes">
            <input type="email"
                   id="input-email"
                   placeholder=" "
                   v-model.lazy="email"
            >
            <label>
              Email {{ errors [0]}}
            </label>
          </div>
        </validation-provider>
        <validation-provider class="tw-w-full tw-w-block" name="district" v-slot="{ classes, errors }">
          <div class="input-group input-group-district" :class="classes">
            <select
                id="input-district"
                placeholder=" "
                v-model="district"
            >
              <option disabled selected>Distrito (não obrigatório)</option>
              <option value="aveiro">Aveiro</option>
              <option value="beja">Beja</option>
              <option value="braga">Braga</option>
              <option value="braganca">Bragança</option>
              <option value="castelo-branco">Castelo Branco</option>
              <option value="coimbra">Coimbra</option>
              <option value="evora">Évora</option>
              <option value="faro">Faro</option>
              <option value="guarda">Guarda</option>
              <option value="leiria">Leiria</option>
              <option value="lisboa">Lisboa</option>
              <option value="portalegre">Portalegre</option>
              <option value="porto">Porto</option>
              <option value="santarem">Santarém</option>
              <option value="setubal">Setúbal</option>
              <option value="viana-do-castelo">Viana do Castelo</option>
              <option value="vila-real">Vila Real</option>
              <option value="viseu">Viseu</option>
            </select>
            <label  :class="{'select-placeholder' : !district}">
              Distrito (não obrigatório)
            </label>
          </div>
        </validation-provider>
        <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
          <div class="mb-2">
            <div class="form-check p-0">
              <label class="form-check-label" :class="classes">
                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                <span class="checkmark"></span>
                <span class="tw-text-gray-600">Autorizo que o {{ company }}, utilize os meus dados pessoais para o envio, por qualquer canal, de comunicações comerciais sobre os seus produtos e serviços, nos termos da sua <a href="#" @click.prevent="$store.state.modal.terms = true"><u>política de privacidade</u></a>.</span>
              </label>
            </div>
          </div>
        </validation-provider>
        <div class="tw-text-center tw-mt-4">
          <button
              type="submit"
              class="btn-cta"
              id="submit"
              :disabled="formLoading"
          >
            SAIBA MAIS
          </button>
        </div>
      </fieldset>
    </form>
  </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';

export default {
    name: 'FormComponent',
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',
            district: '',

            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        formSubmit() {
            this.formLoading = true;

            let cmpInfo = {
                vendor: {
                    consents: [],
                },
                tcString: '',
            };

            try {
                cmpInfo = __tcfapi('getTCData');
            } catch (e) {
                console.log('No CMP Info');
            }

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                fullName: this.fullName,
                phone: this.phone,
                email: this.email,
                district: this.district,
                page: 'investir.bancoinvest.pt/b',

                consent: cmpInfo.vendor.consents.hasOwnProperty('702'),
                tcString: cmpInfo.tcString,
                mclic: process.env.VUE_APP_MCLIC,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'já registado';
                    }
                    if (error.response.data.errors.phone) {
                        error.response.data.errors.phone = 'já registado';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
</style>
